import { useState, useEffect } from 'react';
import { ProductCategory } from '../types/product.types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

interface UseProductCategoriesReturn {
  categories: ProductCategory[];
  loading: boolean;
  error: string | null;
  refreshCategories: () => Promise<void>;
}

export const useProductCategories = (): UseProductCategoriesReturn => {
  const [categories, setCategories] = useState<ProductCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    try {
      console.log('🔍 useProductCategories: Fetching categories from API...');
      setLoading(true);
      setError(null);

      // Hacer petición directa al endpoint de categorías
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${API_BASE_URL}/products/categories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ useProductCategories: API Response:', data);
      setCategories(data.data || []);
    } catch (err) {
      console.error('❌ useProductCategories: Error fetching categories:', err);
      setError('Error al cargar las categorías');
      // Fallback to empty array if there's an error
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const refreshCategories = async () => {
    await fetchCategories();
  };

  return {
    categories,
    loading,
    error,
    refreshCategories
  };
};

// Helper function to get category options for dropdowns
export const useCategoryOptions = () => {
  const { categories, loading, error } = useProductCategories();

  console.log('🎯 useCategoryOptions: categories=', categories, 'loading=', loading, 'error=', error);

  const categoryOptions = [
    { value: 'all', label: 'Todas las categorías' },
    ...categories.map(category => ({
      value: String(category.id), // Usar ID para filtrar correctamente
      label: category.name,
      id: category.id,
      code: category.code
    }))
  ];

  console.log('📋 useCategoryOptions: Generated options=', categoryOptions);

  return {
    categoryOptions,
    categories,
    loading,
    error
  };
};